import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable.tsx'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const GrupoUnidadMedidaGestionApp = Loadable(lazy(() => import('./view/GumGestion.tsx')))
const GumRegistroApp = Loadable(lazy(() => import('./view/registro/GumRegistro.tsx')))
const GumActualizarApp = Loadable(lazy(() => import('./view/actualizar/GumActualizar.tsx')))

export const gumRoutesMap = {
  gestion: {
    path: '/grupo-unidad-medida/gestion',
    name: 'Grupo unidades medida',
    action: 'GRUPO_UNIDADES_MEDIDA',
  },
  registro: {
    path: '/grupo-unidad-medida/nuevo',
    name: 'Nuevo grupo unidad medida',
    action: 'ADMINISTRAR_UNIDADES_MEDIDA',
  },
  actualizar: {
    path: '/grupo-unidad-medida/actualizar/:id',
    name: 'Actualizar Grupo unidad Medida',
    action: 'ADMINISTRAR_UNIDADES_MEDIDA',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const gumRoutes = [
  {
    path: gumRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <GrupoUnidadMedidaGestionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: gumRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <GumRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: gumRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <GumActualizarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default gumRoutes
